import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css'


// Components
import Navbar from "./components/Navbar";

// Pages
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Impressum from "./pages/Impressum";
import Data from "./pages/Data";


function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main className="page-wrapper">
          <Routes>
            {/* Startseite */}
            <Route path="/" element={<Home />} />

            {/* Kontaktseite */}
            <Route path="/contact" element={<Contact />} />

            {/* Impressum */}
            <Route path="/impressum" element={<Impressum />} />

            <Route path="/datenschutz" element={<Data />} />

          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
